<template>
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.66699 7.28516H12.3337M12.3337 7.28516L7.66699 1.28516M12.3337 7.28516L7.66699 13.2852"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<style lang="scss" scoped>
path {
  stroke: currentColor;
}
.icon-arrow-right {
  svg {
    width: 0.762rem;
    height: 0.857rem;
  }
}
</style>
